<div class="font-bold mb-3" i18n>
  5G defines a privacy protection mechanism called Subscription Concealing. International Mobile Subscriber Identity (IMSI) is the primary
  identifier (aka Subscription Permanent Identifier - SUPI) used during network authentication. Subscription Concealing enables IMSI
  encryption via 3GPP-defined Elliptic Curve Integrated Encryption Scheme (ECIS). The outcome is Subscription Concealed Identifier (SUCI)
</div>
<div class="font-bold mb-3" i18n>Let's define the configuration for SUCI Calculation. First, where do you want SUCI to be calculated?</div>
<div class="ml-6">
  <table style="border-collapse: separate; border-spacing: 0 20px">
    <ng-container *ngIf="+profileValues.generalInformation.tsaSpec_gte_2p3 !== 1">
      <tr>
        <td>
          <p-radioButton
            (onClick)="updateSUCI()"
            name="suciEncryptionScheme.suciCalculation"
            inputId="suciEncryptionScheme.suciCalculation#1"
            value="1"
            [(ngModel)]="profileValues.suciEncryptionScheme.suciCalculation"
            [disabled]="+profileValues.generalInformation.tsaSpec_gte_2p3 === 1"
          ></p-radioButton>
        </td>
        <td>
          <label class="ml-2 label-clickable" for="suciEncryptionScheme.suciCalculation#1" i18n>Mobile Equipment</label>
        </td>
      </tr>
      <tr>
        <td>
          <p-radioButton
            (onClick)="updateSUCI()"
            name="suciEncryptionScheme.suciCalculation"
            inputId="suciEncryptionScheme.suciCalculation#2"
            value="2"
            [(ngModel)]="profileValues.suciEncryptionScheme.suciCalculation"
            [disabled]="+profileValues.generalInformation.tsaSpec_gte_2p3 === 1"
          ></p-radioButton>
        </td>
        <td>
          <label class="ml-2 label-clickable" for="suciEncryptionScheme.suciCalculation#2" i18n>USIM</label>
        </td>
      </tr>
    </ng-container>
    <tr *ngIf="+profileValues.generalInformation.tsaSpec_gte_2p3 === 1">
      <td>
        <p-radioButton
          (onClick)="updateSUCI()"
          name="suciEncryptionScheme.suciCalculation"
          inputId="suciEncryptionScheme.suciCalculation#3"
          value="3"
          [(ngModel)]="profileValues.suciEncryptionScheme.suciCalculation"
        ></p-radioButton>
      </td>
      <td>
        <label class="ml-2 label-clickable" for="suciEncryptionScheme.suciCalculation#3" i18n>Other (5G Elements are Excluded)</label>
      </td>
    </tr>
  </table>
</div>
